// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2wRFm","label":"Section_label__1IuG8","contentWrap":"Section_contentWrap__3qRHB","footer":"Section_footer__2PpOu","footerInner":"Section_footerInner__rUkqz"};